import { IAction, ISuccessResponse } from '@Root/types'
import { put, takeLatest } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import Analytics from '@Utils/Analytics'
import Authorization from '@Utils/Authorization'
import { notifyGTMAboutExternalSignUp } from '@Utils/NotifyGTMAboutExternalLoginAndSignup'
import router from '@Site/Router'

import {
  fetchQuickstartSettingsSuccess,
  fetchQuickstartSettingsFailure,
  startQuickstartProcessingSuccess,
  startQuickstartProcessingFailure,
  finishSurvey,
  finishSurveySuccess,
  finishSurveyFailure,
} from './actions'

import {
  OnboardingActionTypes,
  IFetchQuickstartSettingsSuccessResponseBody,
  IStartQuickstartProcessingPayload,
  IGetForwardingPathSuccessResponseBody,
} from './types'

import * as API from './api'

const call: any = Eff.call

const DASHBOARD_FORWARDING_PATH = '/?alert=false'

function* fetchQuickstartSettingsSaga(_action: IAction) {
  try {
    const response: ISuccessResponse<IFetchQuickstartSettingsSuccessResponseBody> = yield call(API.fetchQuickstartSettings)

    yield put(fetchQuickstartSettingsSuccess(response.data))
  } catch (e) {
    yield put(fetchQuickstartSettingsFailure())
  }
}

export function* startQuickstartProcessingSaga(action: IAction<IStartQuickstartProcessingPayload>) {
  try {
    yield call(API.startQuickstartProcessing, action.payload)

    yield put(startQuickstartProcessingSuccess())
    yield put(finishSurvey())
  } catch (e) {
    yield put(startQuickstartProcessingFailure())
  }
}

function* finishSurveySaga(_action: IAction) {
  if (window.Checksub.cookies.get('onboarding') === 'processed') {
    window.location.href = '/'
  } else {
    try {
      yield call(API.finishSurvey)
      yield put(finishSurveySuccess())

      window.Checksub.cookies.set('onboarding', 'processed', { path: '/' })

      Analytics.track('sign_up')

      if (Authorization.isSignedUpThroughOauth()) {
        notifyGTMAboutExternalSignUp()
      } else {
        Analytics.trackGTMSignUpLogin('sign_up', 'email')
      }

      yield call(router.navigate, '/onboarding/check_email', { replace: true })
    } catch (e) {
      yield put(finishSurveyFailure())
    }
  }
}

function* getForwardingPathSaga(_action: IAction) {
  try {
    const response: ISuccessResponse<IGetForwardingPathSuccessResponseBody> = yield call(API.getForwardingPath)
    const forwardingPath = response.data.forwardingPath

    const origin = window.location.origin
    const targetUrl = forwardingPath ? `${origin}${forwardingPath}` : `${origin}${DASHBOARD_FORWARDING_PATH}`

    window.location.href = targetUrl
  } catch (e) {
    window.location.href = `${window.location.origin}${DASHBOARD_FORWARDING_PATH}`
  }
}

function* onboardingSagas() {
  yield takeLatest(OnboardingActionTypes.FETCH_QUICKSTART_SETTINGS, fetchQuickstartSettingsSaga)
  yield takeLatest(OnboardingActionTypes.START_QUICKSTART_PROCESSING, startQuickstartProcessingSaga)
  yield takeLatest(OnboardingActionTypes.FINISH_SURVEY, finishSurveySaga)
  yield takeLatest(OnboardingActionTypes.GET_FORWARDING_PATH, getForwardingPathSaga)
}

export default onboardingSagas
